const RETURN_URL_KEY = "injoy_return_url";

/** Save current path+search+hash so we can restore it after login. */
export const saveReturnUrl = () => {
	const { pathname, search, hash } = window.location;
	// Only save non-trivial paths (skip "/" and "/login")
	if (pathname !== "/" && pathname !== "/login") {
		sessionStorage.setItem(RETURN_URL_KEY, pathname + search + hash);
	}
};

/** Read and delete the saved return URL. Returns null if none. */
export const consumeReturnUrl = (): string | null => {
	const url = sessionStorage.getItem(RETURN_URL_KEY);
	sessionStorage.removeItem(RETURN_URL_KEY);
	return url;
};
